import script from "./ContentTitle.vue?vue&type=script&setup=true&lang=js"
export * from "./ContentTitle.vue?vue&type=script&setup=true&lang=js"

import "./ContentTitle.vue?vue&type=style&index=0&id=221f6254&lang=scss"

const __exports__ = script;

export default __exports__